import { useState, useEffect } from 'react';
import { getCurrentLocale } from '../services/api';

export const useApi = (apiFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Include locale as an implicit dependency so content refetches when language changes
    let locale = 'nl';
    try {
      locale = getCurrentLocale();
    } catch (_) {}

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Add better error checking for apiFunction
        if (typeof apiFunction !== 'function') {
          throw new Error(`useApi: apiFunction is not a function. Received: ${typeof apiFunction}`);
        }
        
        const result = await apiFunction();
        setData(result);
      } catch (err) {
        setError(err);
        console.error('API Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, typeof window !== 'undefined' ? getCurrentLocale() : 'nl']);

  return { data, loading, error };
}; 